import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadRoutingProfileListEpic } from './_epics/loadRoutingProfileList.epic';
import { createRoutingProfileEpic } from './_epics/createRoutingProfile.epic';
import { updateRoutingProfileEpic } from './_epics/updateRoutingProfile.epic';
import { removeRoutingProfileEpic } from './_epics/removeRoutingProfile.epic';
import { exportRoutingProfileEpic } from './_epics/exportRoutingProfile.epic';

export const routingProfileEpic = safeCombineEpics(
  loadRoutingProfileListEpic,
  createRoutingProfileEpic,
  updateRoutingProfileEpic,
  removeRoutingProfileEpic,
  exportRoutingProfileEpic,
);
